import { useMutation } from "@apollo/client";
import { Button, CircularProgress } from "@mui/material";
import {
    PaymentElement,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";
import { MemorabuilaErrorModel } from "components/MemorabuilaErrorModel";
import { useAppState } from "providers/AppState";
import { checkoutPayment } from "queries/checkoutPayment";
import { stripePayment } from "queries/stripePayment";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { stripeInput, stripeResponse } from "types/stripePayment";
import { insertApiResponseDataDog, insertApiResponseDataDogError } from "utils";

export const CheckoutForm = ({ onReady }: { onReady: () => void }) => {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const appState = useAppState();


    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const clientSecret = localStorage.getItem("stripeSecretkey") ?? "";
    const [memorabuilaErrorModel, setmemorabuilaErrorModel] =
        React.useState(false);
    const [setPayAthlete, { loading }] = useMutation<
        stripeResponse,
        stripeInput
    >(stripePayment);
    const location = useLocation();

    const athleteData: any = location.state;
    console.log("athleteData =>", athleteData);
    const tax: number = athleteData.tax || 0;
    const merchantTransactionId: string = athleteData.merchantTransactionId;
    const paymentIntentId: string = athleteData.paymentIntentId;
    const paymentMethodId: string = athleteData.paymentMethodId;

    const userId: any = athleteData.id || "";

    const amount: number = athleteData.amount || 0;

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (elements == null || stripe == null) {
            return;
        }

        // Trigger form validation and wallet collection
        const { error: submitError } = await elements.submit();
        if (submitError?.message) {
            // Show error to your customer
            setErrorMessage(submitError.message);
            //  console.error(error);
            return;
        }

        const { error, setupIntent } = await stripe.confirmSetup({
            //`Elements` instance that was used to create the Payment Element
            elements,
            clientSecret,
            confirmParams: {
                return_url: `${window.location.origin}/success`,
            },
            redirect: "if_required",
        });
        console.log("setupIntent", setupIntent);
        if (error?.message) {
            // Show error to your customer
            setErrorMessage(error.message);
            // console.error(error);
            return;
        }

        const setAthletePayment = async () => {
            try {
                const res = await setPayAthlete({
                    variables: {
                        athleteUserIds: userId,
                        paymentInfo: {
                            transactionId: paymentIntentId ?? setupIntent?.id,
                            merchantTransactionId: merchantTransactionId,
                            paymentMethodId: paymentMethodId ?? setupIntent?.payment_method?.toString(),
                            amount: amount,
                            tax: tax,
                        },
                        savedCardId: "",
                    },
                });
                insertApiResponseDataDog(
                    "purchaseMemorabiliaApi(success)",
                    res,
                    "info"
                );
                if (res?.data?.purchaseMemorabiliaWithStripe.status === 200) {
                    appState.setAmount(null);
                    localStorage.setItem("valid", "");
                    navigate(`/fanhome?transaction=completed&id=${userId}`);
                } else {
                    insertApiResponseDataDog(
                        "purchaseMemorabiliaApi(success)",
                        res,
                        "info"
                    );
                    setmemorabuilaErrorModel(true);
                }
            } catch (error) {
                insertApiResponseDataDogError(
                    error,
                    "purchaseMemorabiliaApi(error)"
                );
                insertApiResponseDataDog(
                    "purchaseMemorabiliaApi(error)",
                    error,
                    "error"
                );
                setmemorabuilaErrorModel(true);
            }
        };
        if (setupIntent?.id) {
            setAthletePayment();

        }

        // localStorage.setItem("cardPaymentToken", data.token)
        //   localStorage.setItem("valid", "valid");
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.

    };

    return (
        <>
            {memorabuilaErrorModel && (
                <MemorabuilaErrorModel
                    open={memorabuilaErrorModel}
                    setOpen={setmemorabuilaErrorModel}
                    amount={Number("123")}
                    id={"123"}
                    tax={Number("120")}
                />
            )}
            <form onSubmit={handleSubmit} className="px-4">
                <PaymentElement onReady={onReady} />
                <Button
                    startIcon={loading ? <CircularProgress size={20} /> : null}
                    sx={{ mt: 8 }}
                    type="submit"
                    fullWidth
                    color={"primary"}
                    variant="contained"
                    disabled={!stripe || !elements}
                >
                    Pay
                </Button>

                {/* Show error message to your customers */}
                {errorMessage && <div style={{ marginTop: "10px", color: "red", padding: "10px" }}>{errorMessage}</div>}
            </form>
        </>
    );
};
